import React from 'react';
import { Query } from 'react-apollo';
import gql from 'graphql-tag';

import { Loader } from '../Loader';
import { Error } from '../Error';
import { NoResult } from '../NoResult';

import Widget, { WidgetTitle, WidgetContent } from './Widget';
import PartGroupsWithTypesCheckboxList from '../PartGroupsWithTypesCheckboxList';

const GET_GROUPS = gql`
  query getPartGroups {
    groups: getPartGroups {
      items {
        value: GruppId
        label: GruppNamn
      }
    }
  }
`;

export default function PartGroupsWithTypesCheckboxWidget() {
  return (
    <Widget>
      <WidgetTitle>Delegrupper</WidgetTitle>

      <WidgetContent>
        <Query query={GET_GROUPS}>
          {({ loading, error, data }) => {
            if (loading) {
              return <Loader />;
            }

            if (error) {
              return <Error error={error} />;
            }

            if (!data.groups.items) {
              return <NoResult msg="Ingen delegrupper ble funnet!" />;
            }

            return (
              <PartGroupsWithTypesCheckboxList groups={data.groups.items} />
            );
          }}
        </Query>
      </WidgetContent>
    </Widget>
  );
}
